import { AuthenticateState } from './';
import produce from 'immer';
import { AuthField, AuthType } from './types';
import { utils } from '../CreateWedding/components/Auth/utils';

export namespace handlers {
  export const handleFormInput = (field: string = '', value: string | Date = '') =>
    produce<AuthenticateState>(draft => {
      draft[field].value = value;
      if (draft[field].error) {
        draft[field].error = false;
      }
    });

  export const handleSubmit = () =>
    produce<AuthenticateState>(draft => {
      draft.email = { error: false, value: '', errorText: '' };
      draft.password = { error: false, value: '', errorText: '' };
    });

  export const handleError = (field: string, e: any) =>
    produce<AuthenticateState>(draft => {
      draft[field] = e.description ? e.description : 'An unknown error occurred.';
    });

  export const handleInputErrors = (email: AuthField, password: AuthField, authType: AuthType) => {
    return produce<AuthenticateState>(draft => {
      if (authType === 'signup') {
        draft.email.error = !utils.isValidEmail(email.value);
        draft.password.error = !utils.isValidPassword(password.value);
      } else {
        draft.email.error = utils.isEmpty(email);
        draft.password.error = utils.isEmpty(password);
      }
      draft.email.errorText = utils.getErrorText(email, 'email');
      draft.password.errorText = utils.getErrorText(password, 'password');
    });
  };
}
